//TODO: update with yours
export interface InteractionConfig {
	msgFrom: string;
	message: string;
	timeout?: number; // time after which the interaction gets hidden - in ms
}

//TODO: update with yours
export function validateConfig(c: InteractionConfig): boolean {
	if (!c) {
		return false;
	}
	if (!c.timeout) {
		c.timeout = Number(new URLSearchParams(window.location.search).get('timeout') || '20000');
	}
	return true;
}
